import { Component, Host } from '@angular/core';
import { CardComponent } from './card.component';

@Component({
  selector: 'mars-card-content',
  template: `
    <section class="mars-card-content" id="card-content">
      <ng-content></ng-content>
    </section>
  `,
  styleUrls: ['./card-content.component.scss'],
})
export class CardContentComponent {
  constructor(@Host() private card: CardComponent) {}
}
